import React from "react";
import { IResultButtonProps } from "../../../types/suggestion-items";
import { ITelemetryData, TelemetryContentEnum } from "../../../types/telemetry";
import { sendTelemetryData } from "../../../util/telemetry";
import { useNavigationContext } from "../../common/contexts";
import ChevronRight from "../../../Assets/svg/Chevron_right_icon";

const ResultButton = (props: IResultButtonProps) => {
    const { handleMouseSelect, handleMouseDeselect, handleTouched } = useNavigationContext();

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        handleTouched(props.navIndex);
        recordShowAllResultsUsed();
        window.location.href = props.target;
    };

    const recordShowAllResultsUsed = () => {
        const data: ITelemetryData = {
            correlationId: props.searchInfo.pageViewLogDataId,
            culture: props.searchInfo.culture,
            portal: props.searchInfo.portal,
            searchTerm: props.searchInfo.searchTerm,
            shortLink: "",
            suggestion: TelemetryContentEnum.ShowAllResults,
            contentType: TelemetryContentEnum.ShowAllResults
        };

        sendTelemetryData(data, props.searchInfo.trackingEndpoint);
    };

    return (
        <div ref={(el) => props.setRef(props.navIndex, el)} className="result-button-container">
            <a
                href={props.target}
                onClick={handleClick}
                onMouseEnter={() => handleMouseSelect(props.navIndex)}
                onMouseLeave={handleMouseDeselect}
                className="show-results-button"
                data-testid="show-results-button"
                data-semantic-id="show-results-button"
            >
                <div className="result-button-text">
                    <div className="result-button-content">{props.title}</div>
                    <div className="result-button-icon">
                        <ChevronRight />
                    </div>
                </div>
            </a>
        </div>
    );
};

export default ResultButton;
